import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0","key":"svg-0"}],["path",{"d":"M12 3c7.2 0 9 1.8 9 9c0 7.2 -1.8 9 -9 9c-7.2 0 -9 -1.8 -9 -9c0 -7.2 1.8 -9 9 -9","key":"svg-1"}]]

const IconSquareRoundedLetterC = createReactComponent('outline', 'square-rounded-letter-c', 'SquareRoundedLetterC', __iconNode);

export default IconSquareRoundedLetterC;